import PropTypes from 'prop-types';

import AccordionItem from '../AccordionItem';
import AccordionFade from '../AccordionFade';

import { t } from '../../i18n';

const EditorialAccordionBlock = ({
    layout,
    expandedByDefault,
    title,
    content,
    updatedAt,
}) => {
    if (layout === 'column') {
        return (
            <AccordionFade
                title={title}
                content={content}
                description={updatedAt}
                open={expandedByDefault}
            />
        );
    }

    if (layout === 'small-column-blue') {
        const lowerCaseTitle = title ? title.toLowerCase() : '';

        return (
            <AccordionItem
                blackHeaderBackground={true}
                title={`${t('general.read')} ${lowerCaseTitle}`}
                titleOpen={`${t('general.close')} ${lowerCaseTitle}`}
                childrenTitle={title}
                description={''}
                content={content}
                open={expandedByDefault}
            />
        );
    }

    return (
        <AccordionItem
            size={layout}
            title={title}
            content={content}
            open={expandedByDefault}
        />
    );
};

EditorialAccordionBlock.propTypes = {
    layout: PropTypes.oneOf(['small', 'small-column-blue', 'large', 'column']),
    title: PropTypes.string,
    content: PropTypes.string,
    updatedAt: PropTypes.string,
};

export default EditorialAccordionBlock;
